var _path, _path2, _path3, _path4, _polygon, _path5, _polygon2, _path6, _path7, _circle, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _circle2, _circle3, _circle4, _path14, _path15, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 697.27953,
    height: 410,
    viewBox: "0 0 697.27953 410",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M926.423,592.27145c-6.67772,23.16587-26.17584,39.38224-46.51484,53.15782q-4.25982,2.88575-8.52233,5.63873c-.01925.00841-.03909.02638-.05858.035-.13671.08782-.2737.17584-.40108.26423-.58649.378-1.17319.75635-1.7548,1.13l.31948.14352s.31372.16681-.02951.02674c-.10215-.04272-.20917-.0811-.31111-.12407C857.3345,647.778,845.309,642.66141,836.254,633.73415c-9.39316-9.27036-14.88249-23.81052-9.79618-35.98909a23.25206,23.25206,0,0,1,2.51773-4.519c.41257-.59038.85691-1.15543,1.31955-1.71a24.92317,24.92317,0,0,1,42.80629,7.57346c1.49426-13.91262-9.97777-25.56652-21.01792-34.16538-11.045-8.59451-23.59524-17.95413-25.73053-31.78953-1.19244-7.69783,1.48441-15.15777,6.36066-21.14635.151-.182.30172-.36367.45721-.54064a36.37308,36.37308,0,0,1,23.37837-12.54206c16.9361-1.76017,33.38692,7.20443,45.69063,18.97982C922.04259,536.83124,934.01422,565.932,926.423,592.27145Z",
    transform: "translate(-251.36024 -245)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M894.58919,561.97074A61.832,61.832,0,0,1,901.997,578.309a53.68952,53.68952,0,0,1,1.85579,15.857,68.78974,68.78974,0,0,1-9.00949,31.3056,99.00474,99.00474,0,0,1-14.93515,19.95764q-4.25982,2.88575-8.52233,5.63873c-.01925.00841-.03909.02638-.05858.035-.13671.08782-.2737.17584-.40108.26423-.58649.378-1.17319.75635-1.7548,1.13,0,0,.6332.31033.29.17026-.10215-.04272-.20917-.0811-.31111-.12407a54.72761,54.72761,0,0,0-17.5121-47.12213,55.19644,55.19644,0,0,0-22.66249-12.19524c.41257-.59038.85691-1.15543,1.31955-1.71a57.22863,57.22863,0,0,1,9.4462,3.57454,56.07474,56.07474,0,0,1,25.35391,24.4441,57.33022,57.33022,0,0,1,6.24208,31.45986c.48548-.43993.97154-.88942,1.44295-1.33466,8.97864-8.37088,16.95346-17.97929,22.35056-29.0682a63.99532,63.99532,0,0,0,6.70117-30.27837c-.44047-11.43765-4.99764-22.03186-11.59581-31.25473a133.95526,133.95526,0,0,0-25.39185-26.169,152.21249,152.21249,0,0,0-31.58-19.49684,1.09437,1.09437,0,0,1-.55075-1.40454.93075.93075,0,0,1,.45721-.54064.81033.81033,0,0,1,.70374.0299c1.393.64129,2.77635,1.29135,4.1486,1.96952a153.94,153.94,0,0,1,31.805,20.98C879.19,542.40862,888.00365,551.52751,894.58919,561.97074Z",
    transform: "translate(-251.36024 -245)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M655.74918,454.9118a10.05581,10.05581,0,0,0,5.277-14.48823l23.35886-27.04334-18.41436-2.3969-19.35885,26.04829a10.11027,10.11027,0,0,0,9.13732,17.88018Z",
    transform: "translate(-251.36024 -245)",
    fill: "#ffb8b8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M787.41329,460.62632a10.05573,10.05573,0,0,0-2.36251-15.23726l7.42514-34.95492-17.28821,6.77876-4.40056,32.15453a10.11027,10.11027,0,0,0,16.62614,11.25889Z",
    transform: "translate(-251.36024 -245)",
    fill: "#ffb8b8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "452.389 397.799 440.129 397.798 434.297 350.51 452.391 350.511 452.389 397.799",
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M706.87559,654.68268l-39.53052-.00146v-.5A15.38605,15.38605,0,0,1,682.73154,638.795h.001l24.1438.001Z",
    transform: "translate(-251.36024 -245)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "512.389 397.799 500.129 397.798 494.297 350.51 512.391 350.511 512.389 397.799",
    fill: "#ffb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M766.87559,654.68268l-39.53052-.00146v-.5A15.38605,15.38605,0,0,1,742.73154,638.795h.001l24.1438.001Z",
    transform: "translate(-251.36024 -245)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M705.02644,618.10638l-17.35473-.69433a4.51414,4.51414,0,0,1-4.31788-4.63379l4.88941-160.37891.31934-.11523c30.41625-11.00293,55.57836-10.1709,76.926,2.54l.23877.14258,2.929,156.20214a4.49957,4.49957,0,0,1-4.49926,4.585H749.523a4.51,4.51,0,0,1-4.41577-3.63184L725.17219,510.71283a1.49976,1.49976,0,0,0-2.96069.10937L709.67341,614.15228a4.52551,4.52551,0,0,1-4.46923,3.957C705.14534,618.10931,705.08577,618.10834,705.02644,618.10638Z",
    transform: "translate(-251.36024 -245)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 470.54967,
    cy: 42.19085,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M664.04951,435.39a4.50569,4.50569,0,0,1-2.09059-1.68576l-4.74579-7.10154a4.51469,4.51469,0,0,1,.11893-5.16938l19.132-25.96774,11.9859-57.511a14.49652,14.49652,0,1,1,27.01712,10.52l-5.66482,36.60153a46.37352,46.37352,0,0,1-16.02389,28.44079l-25.18508,21.13438a4.505,4.505,0,0,1-3.52808,1.00768A4.45444,4.45444,0,0,1,664.04951,435.39Z",
    transform: "translate(-251.36024 -245)",
    fill: "#6c63ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M786.36458,437.99578a4.50565,4.50565,0,0,1-2.68308.11591l-8.25448-2.195a4.51469,4.51469,0,0,1-3.32625-3.95888l-2.7964-32.13311-29.00182-51.08889a14.49652,14.49652,0,1,1,27.23068-9.95418l19.93124,31.2171a46.37349,46.37349,0,0,1,6.76343,31.93587l-4.94075,32.50445a4.505,4.505,0,0,1-1.98248,3.08748A4.45507,4.45507,0,0,1,786.36458,437.99578Z",
    transform: "translate(-251.36024 -245)",
    fill: "#6c63ff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M695.04524,330.80811a41.82248,41.82248,0,0,1,33.53711-13.55957q.616.03809,1.227.08593h.00049A41.73428,41.73428,0,0,1,759.96956,333.981a42.362,42.362,0,0,1,7.5249,34.14453,132.361,132.361,0,0,0,3.49658,67.876l6.58887,20.459a4.49852,4.49852,0,0,1-4.042,5.87207l-33.68506,1.811-8.62012-14.8897V464.607l-40.94092,2.20112c-.08154.00488-.16259.00683-.24316.00683a4.5,4.5,0,0,1-4.48389-4.86133l4.62744-57.38183-5.8042-38.97266A42.08924,42.08924,0,0,1,695.04524,330.80811Z",
    transform: "translate(-251.36024 -245)",
    fill: "#6c63ff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M738.97975,310.63785c-2.274,1.30843-11.26246,2.176-11.90278-.36827l-.01372-.0559c-.44576-1.86411-.0756-3.81068.05233-5.72308s-.05925-4.01326-1.36175-5.41937c-2.428-2.62114-6.74756-1.23165-10.25844-1.89439a8.66429,8.66429,0,0,1-6.74006-9.25292c.05-.3975.12841-.79544.21633-1.19315a6.67288,6.67288,0,0,0-6.92675-8.08129c-3.54811.20288-7.378,1.27789-10.31358-1.35012-2.2701-2.03223-2.82395-7.32236-1.82653-10.20133,1.67623-4.83831,12.4137-7.37125,17.10185-8.76367A40.62027,40.62027,0,0,1,741.437,263.9839c2.96119,2.08724,5.72662,4.70984,6.98873,8.10576s.65323,7.68029-2.19277,9.92206a18.332,18.332,0,0,1,4.24619,17.80643C749.07347,304.3476,742.36471,308.69018,738.97975,310.63785Z",
    transform: "translate(-251.36024 -245)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M517.36024,383h-221a1,1,0,0,1,0-2h221a1,1,0,0,1,0,2Z",
    transform: "translate(-251.36024 -245)",
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M468.95862,383H343.36024a1,1,0,0,1,0-2H468.95862a1,1,0,0,1,0,2Z",
    transform: "translate(-251.36024 -245)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M407.36024,383a1,1,0,0,1-1-1V319a1,1,0,0,1,2,0v63A1.00005,1.00005,0,0,1,407.36024,383Z",
    transform: "translate(-251.36024 -245)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M470.36024,383a1,1,0,0,1-1-1V256a1,1,0,0,1,2,0V382A1.00005,1.00005,0,0,1,470.36024,383Z",
    transform: "translate(-251.36024 -245)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 74,
    r: 11,
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 137,
    r: 11,
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M517.36024,257h-221a1,1,0,0,1,0-2h221a1,1,0,0,1,0,2Z",
    transform: "translate(-251.36024 -245)",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M517.36024,320h-221a1,1,0,0,1,0-2h221a1,1,0,0,1,0,2Z",
    transform: "translate(-251.36024 -245)",
    fill: "#e6e6e6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 137,
    r: 11,
    fill: "#6c63ff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 74,
    r: 11,
    fill: "#6c63ff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 137,
    r: 11,
    fill: "#6c63ff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 11,
    r: 11,
    fill: "#6c63ff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 74,
    r: 11,
    fill: "#6c63ff"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 137,
    r: 11,
    fill: "#6c63ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M947.63976,655h-439a1,1,0,0,1,0-2h439a1,1,0,0,1,0,2Z",
    transform: "translate(-251.36024 -245)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M576.36024,566.05286q-.9939-.05156-2-.05286a38,38,0,0,0-38,38h40Z",
    transform: "translate(-251.36024 -245)",
    fill: "#6c63ff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M584.36024,655a39.04406,39.04406,0,0,1-39-39,1,1,0,0,1,1-1h39V578.05273a.99848.99848,0,0,1,.31152-.72509.97931.97931,0,0,1,.74023-.27344A38.9999,38.9999,0,0,1,584.36024,655Zm-36.98658-38a37.00006,37.00006,0,1,0,39.98658-37.87939V616a1.00005,1.00005,0,0,1-1,1Z",
    transform: "translate(-251.36024 -245)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.71635338962dd17231416b488f2c505a.svg";
export { ForwardRef as ReactComponent };